import { InputLabel, OutlinedInput } from "@mui/material";
import { produce } from "immer";
import React from "react";
import FormSection from "../../../../../Components/Forms/FormSection/form-section";
import { SectionGlobalProps } from "../settings-global";
import { useTranslation } from "react-i18next";

const SettingsGlobalSectionWowza: React.FC<SectionGlobalProps> = (props) => {
  const { t } = useTranslation();
  const { platformInfos, setPlatformInfos } = props;

  return (
    <FormSection title={t("form:section.title.wowza")} status="todo" sx={{ mb: 2 }}>
      <InputLabel sx={{ mb: 1 }}>{t("field:label.docRootPath")}</InputLabel>
      <OutlinedInput
        value={platformInfos.wowzaDocRootPath || ""}
        id={"wowzaDocRootPath"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.wowzaDocRootPath = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.publicBaseUrl")}</InputLabel>
      <OutlinedInput
        value={platformInfos.wowzaPublicBaseUrl || ""}
        id={"wowzaPublicBaseUrl"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.wowzaPublicBaseUrl = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.serviceName")}</InputLabel>
      <OutlinedInput
        value={platformInfos.wowzaServiceName || ""}
        id={"wowzaServiceName"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.wowzaServiceName = e.currentTarget.value;
            })
          )
        }
      />
    </FormSection>
  );
};

export default SettingsGlobalSectionWowza;
